export default class ProductImagesCollection {

    constructor($scope, images) {
        this.$scope = $scope;
        this.index = 0;
        this.currentImage = null;
        this.imagesMap = new Map();
        this.images = images;
        this.displayedImages = [];
        this.currentImageIndex = 1;
        this.lastImageIndex = 1;
        this.events = new Map();
        this.lastDirection = 'left';
        this.oldImage = null;
        this.$modalTimeout = null;
    }

    registerModalTimeout($timeout) {
        this.$modalTimeout = $timeout;
    }

    registerEvent(eventId, callback) {
        let registeredEvents = this.events.has(eventId) ? this.events.get(eventId) : [];
        registeredEvents.push(callback);
        this.events.set(eventId, registeredEvents);
    }

    fireEventCallbacks(eventId, argument1 = null, argument2 = null) {
        if (!this.events.has(eventId)) {
            return;
        }

        const registeredEvents = this.events.get(eventId);

        registeredEvents.forEach(callback => {
            callback(argument1, argument2);
        });
    }

    // Check if the previous photo is available
    hasPrevPhoto() {
        return this.currentImageIndex > 0;
    }

    // Check if the next photo is available
    hasNextPhoto() {
        return this.currentImageIndex < this.images.length - 1;
    }

    // Display next photo
    nextPhoto() {
        if (this.hasNextPhoto()) {
            this.lastImageIndex = this.currentImageIndex;
            this.currentImageIndex++;
            this.setActiveImage(this.images[this.currentImageIndex]);
        }
    }

    // Display previous photo
    prevPhoto() {
        if (this.hasPrevPhoto()) {
            this.lastDirection = 'left';
            this.lastImageIndex = this.currentImageIndex;
            this.currentImageIndex--;
            this.setActiveImage(this.images[this.currentImageIndex]);
        }
    }

    getActiveImage() {
        return this.currentImage;
    }

    setCurrentImage(newImage) {
        this.lastImageIndex = this.currentImageIndex;
        this.images.find((image, index) => {
            if (newImage.id === image.id) {
                this.currentImageIndex = index;
                this.setActiveImage(image);
            }
        });
    }

    setActiveImage(image) {
        if (image === this.currentImage) {
            return;
        }

        if(this.lastImageIndex < this.currentImageIndex) {
            this.lastDirection = 'right';
        } else {
            this.lastDirection = 'left';
        }

        if (this.currentImage) {
            this.currentImage.setDirection(this.lastDirection === 'left' ? 'right' : 'left');
        }

        this.index++;
        this.imagesMap.set(image.id, {index: this.index, image: image});
        this.currentImage = image;

        this.currentImage.setDirection(this.lastDirection);

        this.fireEventCallbacks('onActiveImageChanged', image, this.lastDirection);

        this.imagesMap.forEach((oldImage, id) => {
            if (id !== image.id) {
                oldImage.image.hide();
            }
        });

        $.ajax({
            url: image.file.getPathForSize(800, 600),
            success: () => {
                image.show();
                this.$scope.$apply();
            }
        });

        this.displayedImages = Array.from(this.imagesMap.values());
    }
}
